import { Text, View, StyleSheet, Font } from "@react-pdf/renderer";
import React from "react";
import Footer from "../Footer";

const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    textAlign: "left",
    alignItems: "flex-start",
    fontFamily: "Lato",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  tocSection: {
    width: "100%",
    paddingLeft: "20px",
    paddingRight: "20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "10px",
  },
  tocItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    fontSize: "18px",
    fontWeight: "600",
    color: "#245775",
    lineHeight: "58px",
    color: "#426B88",
    // marginBottom: "10px",
    fontFamily: "Lato",
  },
  tocNumber: {
    fontWeight: "600",
  },
});

const TableContent = ({ pageNumbers }) => {
  const contents = [
    "OVERVIEW",
    "ABOUT YOUR REPORT",
    "STARTER QUADRANT",
    "QUADRANT FLOW",
    "LEADERSHIP STYLE",
    "MINDSET",
    "REFLECT AND INTEGRATE",
  ];

  const defaultPageNumbers = [3, 4, 5, 6, 7, 8, 9];
  const displayPageNumbers = pageNumbers || defaultPageNumbers;

  return (
    <View style={styles.coverSection}>
      <Text style={styles.coverTitle}>TABLE OF CONTENTS</Text>
      <View style={styles.tocSection}>
        {contents.map((item, index) => (
          <View key={index} style={styles.tocItem}>
            <Text>{`${index + 1}. ${item}`}</Text>
            <Text style={styles.tocNumber}>
              {String(displayPageNumbers[index] || 0).padStart(2, '0')}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
};

export default TableContent;
